export const events = {
    "KYCPageVisited": "KYC page- visited",
    "KYCPageInfoAutoPopulated": "KYC page- information auto populated",
    "KYCPageClickedConfirm": "KYC page- clicked confirm/next",
    "EmailVerificationPageVisited": "Email verification page- visited",
    "PaymentConfirmPageVisited": "Payment confirmation page- visited",
    "PaymentConfirmationPageClickedOnCheckbox": "Payment confirmation page- clicked on deferred payment agreement",
    "PaymentConfirmationPageClickedConfirm": "Payment confirmation page- clicked confirm"
}